import React, { useState, useCallback } from "react";
import CSHMessage from "./CSHMessage";

// Custom hook to show CSHMessage and get result as a promise
export function useCSHMessage() {
  const [messageProps, setMessageProps] = useState(null);

  const showMessage = useCallback(
    (options) =>
      new Promise((resolve) => {
        const { type = "info", messageType = "info" } = options || {};
        setMessageProps({
          ...options,
          isOpen: true,
          type,
          messageType,
          onClose: () => {
            setMessageProps(null);
            resolve(undefined); // For OK/info
          },
          onYes: () => {
            setMessageProps(null);
            resolve(true);
          },
          onNo: () => {
            setMessageProps(null);
            resolve(false);
          }
        });
      }),
    []
  );

  const message = messageProps ? <CSHMessage {...messageProps} /> : null;

  return [showMessage, message];
}